import {connect} from 'react-redux';

import {setUsersAction} from './Redux/UsersActions';
import UsersContainer from './UsersContainer';
import {UsersState} from './UsersTypes';

export type UserState = {users: UsersState}

export const mapState = (state: UserState): UsersState => {
    const {users} = state;
    
    return users;
};

export const mapDispatch = {
    setUsers: setUsersAction,
};

export default connect(mapState, mapDispatch)(UsersContainer);
